import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export enum HouseholdClaimState {
    Booked = "Reservado",
    Processing = "Procesado",
}

export class HouseholdClaim extends BaseModel {
    @Expose() id = 0;
    @Expose() createdDate = "";
    @Expose() state: HouseholdClaimState = HouseholdClaimState.Booked;
}
